// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1L-ZS","location":"Header_location__1cC4W"};